import { generateMatrix } from '../../helper'
import { icons } from '../../data'

export const arrPopup1 = [
  { text: 'Толя любит приложение "Музыка" за то, что не нужно составлять плейлист, оно само подбирает ему песни. При чём, большинство музыкальных композиций Толе нравится. Но ведь и наш Робот сможет так же, нужно его только научить!\n' },
  { text: 'Перед тобой таблица реакций пользователей на разные песни. Что означает каждая реакция, ты можешь увидеть в легенде.\n' },
  { text: 'Так как самый универсальный способ расчёта - математический, то переведём реакции пользователей на песни в числа.' },
  { text: 'Задание: заменить пиктограммы на числа, которые им соответствуют.', buttonTitle: 'Начать' },
]

export const arrPopup2 = [
  { text: 'Чтобы определить, насколько совпадают реакции разных пользователей относительно какой-то песни, нужно найти произведение чисел, обозначающих их реакцию.\n' },
  { text: 'Перед тобой таблица реакций пользователей на разные песни. Что означает каждая реакция, ты можешь увидеть в легенде.\n' },
  { text: 'Так как нам нужно определить рекомендации для Толи, то мы каждую его реакцию умножаем на реакцию каждого другого пользователя по данной песне (т.е. каждую реакцию Толи умножаем на каждую в соответствующем столбце). \n' },
  { text: 'Задание: найди произведение реакции Толи на реакцию каждого профиля по столбцам и запиши результаты <span class="textBold">в пустое место в ячейке.</span>', buttonTitle: 'Начать' },
]

export const arrPopup3 = [
  { text: 'Как теперь по полученным числам определить совпадение музыкальных предпочтений профилей? Очень просто! Найти сумму полученных произведений.' },
  { text: 'Задание: <span class="textBold">вычисли сумму зеленых чисел</span> в каждой строке и запиши результаты справа.', buttonTitle: 'Начать' },
]
export const arrPopup4 = [
  { text: 'Теперь ты можешь найти тот музыкальный профиль, который максимально совпадает с профилем Толи (по максимальной сумме).', buttonTitle: 'Начать' },
]
export const arrPopup5 = [
  { text: 'Ого, у Егора и у Толи похожие музыкальные интересы! Теперь осталось сказать, стоит ли рекомендовать Толе песню Юли.', buttonTitle: 'Начать' },
  // { text: 'Теперь ты можешь найти тот музыкальный профиль, который максимально совпадает с профилем Толи (по максимальной сумме).', buttonTitle: 'Начать' },
]

export const arrPopupChooseUser = [
  { text: 'Ого, у Егора и у Толи похожие музыкальные интересы! Теперь осталось сказать, стоит ли рекомендовать Толе песню Юли.', buttonTitle: 'Продолжить' },
]

export const task1 = [
  { text: 'Задание: заменить пиктограммы на числа, которые им соответствуют.' },
]
export const task2 = [
  { text: 'Задание: найди произведение реакции Толи на реакцию каждого профиля по столбцам и запиши результаты <span class="textBold">в пустое место в ячейке.</span>' },
]
export const task3 = [
  { text: 'Задание: <span class="textBold">вычисли сумму зеленых чисел</span> в каждой строке и запиши результаты справа.' },
]
export const task4 = [
  { text: 'Задание: Теперь ты можешь найти тот музыкальный профиль, который максимально совпадает с профилем Толи (по максимальной сумме).' },
]
export const task5 = [
  { text: 'Теперь осталось сказать, стоит ли рекомендовать Толе песню Юли.' },
]


const matrix1 = [
  {
    name: 'Илон',
    namePretext: 'Илона',
    matrix: ['-1', '0', '0', '-10', '1', '1', '0'],
    icon: icons.ilon,
  },
  {
    name: 'Егор',
    namePretext: 'Егора',
    icon: icons.egor,
    matrix: ['-1', '1', '10', '1', '0', '-10', '0'],
  },
  {
    name: 'Семен',
    namePretext: 'Семена',
    icon: icons.semen,
    matrix: ['-1', '0', '0', '0', '0', '0', '1'],
  },
  {
    name: 'Клава',
    namePretext: 'Клавы',
    icon: icons.julia,
    matrix: ['0', '-1', '1', '1', '-10', '0', '1'],
  },
  {
    icon: icons.luda,
    name: 'Люда',
    namePretext: 'Люды',
    matrix: ['0', '0', '10', '0', '-10', '1', '-1'],

  },
  {
    name: 'Толя',
    namePretext: 'Толи',
    me: true,
    icon: icons.tolya,
    matrix: ['1', '1', '?', '10', '0', '-10', '0'],
  },
]
const matrix2 = [
  {
    name: 'Илон',
    namePretext: 'Илона',
    matrix: ['0', '0', '1', '1', '-1', '1', '-1'],
    icon: icons.ilon,
  },
  {
    name: 'Егор',
    namePretext: 'Егора',
    icon: icons.egor,
    matrix: ['10', '-10', '-10', '0', '0', '1', '0'],
  },
  {
    name: 'Семен',
    namePretext: 'Семена',
    icon: icons.semen,
    matrix: ['0', '0', '-10', '10', '-1', '0', '0'],
  },
  {
    name: 'Клава',
    namePretext: 'Клавы',
    icon: icons.julia,
    matrix: ['-1', '1', '0', '1', '1', '0', '0'],
  },
  {
    icon: icons.luda,
    name: 'Люда',
    namePretext: 'Люды',
    matrix: ['10', '-10', '0', '0', '1', '1', '1'],

  },
  {
    name: 'Толя',
    namePretext: 'Толи',
    me: true,
    icon: icons.tolya,
    matrix: ['1', '-10', '?', '-10', '0', '0', '10'],
  },
]
const matrix3 = [
  {
    name: 'Илон',
    namePretext: 'Илона',
    matrix: ['0', '-1', '0', '0', '1', '-1', '0'],
    icon: icons.ilon,
  },
  {
    name: 'Егор',
    namePretext: 'Егора',
    icon: icons.egor,
    matrix: ['10', '0', '1', '0', '-10', '-10', '0'],
  },
  {
    name: 'Семен',
    namePretext: 'Семена',
    icon: icons.semen,
    matrix: ['-1', '0', '0', '1', '0', '-1', '1'],
  },
  {
    name: 'Клава',
    namePretext: 'Клавы',
    icon: icons.julia,
    matrix: ['0', '1', '1', '1', '0', '0', '1'],
  },
  {
    icon: icons.luda,
    name: 'Люда',
    namePretext: 'Люды',
    matrix: ['0', '-1', '0', '0', '1', '0', '1'],

  },
  {
    name: 'Толя',
    namePretext: 'Толи',
    me: true,
    icon: icons.tolya,
    matrix: ['1', '0', '10', '10', '0', '?', '1'],
  },
]
export const arrMatrix1 = generateMatrix(matrix1)
export const arrMatrix2 = generateMatrix(matrix2)
export const arrMatrix3 = generateMatrix(matrix3)
